import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { NotificationService } from '../../../notifications/notification.service';
import { ClinicalRecordTypeService } from '../clinical-record-type.service';
import {
    ClinicalRecordTypeActionTypes, LoadClinicalRecordTypesFail, LoadClinicalRecordTypesSuccess
} from './clinical-record-type.actions';

@Injectable()
export class ClinicalRecordTypeEffects {


  constructor(
    private service: ClinicalRecordTypeService,
    private actions$: Actions,
    private notificationService: NotificationService,
    private translateService: TranslateService) {
  }


  @Effect({ dispatch: false })
  genericFail$ = this.actions$.pipe(
    ofType<Action & { payload: string }>(
      ClinicalRecordTypeActionTypes.LoadClinicalRecordTypesFail,
    ),
    tap(action => this.notificationService.error(action.payload))
  );


  @Effect()
  loadUsers$ = this.actions$.pipe(
    ofType(ClinicalRecordTypeActionTypes.LoadClinicalRecordTypes),
    mergeMap(_ =>
      this.service.getAll().pipe(
        map(items =>
        {
          items.forEach(item => item.name = this.translateService.instant(item.name));
          return new LoadClinicalRecordTypesSuccess(items);
        }),
        catchError(err => of(new LoadClinicalRecordTypesFail(err)))
      )
    )
  );

}
